export const facebookUrl =
  "https://www.facebook.com/profile.php?id=61550603774103";
export const instagramUrl = "https://www.instagram.com/agwi_pol/";
export const calendlyUrl = "https://calendly.com/agwipol/meet-with-me";
export const rzetelnaUrl = "https://wizytowka.rzetelnafirma.pl/6FPYR0E2";
export const mapsUrl = "https://maps.app.goo.gl/2xHYWXc752KKkSUD8";

//===== faq doc links =====
export const moveGuide =
  "https://docs.google.com/document/d/1o2N0aOKkc5dmBs2y7XJMWgfgE0oVrelP/edit?usp=sharing&ouid=106267317093893487584&rtpof=true&sd=true";
export const moveChecklist =
  "https://docs.google.com/document/d/1o9viTqrsvatOtsPgpClxgdjeJiZsOuDC/edit?usp=sharing&ouid=106267317093893487584&rtpof=true&sd=true";
export const instructionProfil =
  "https://docs.google.com/document/d/1rzpw40RAD8nhgLGHiNRfYBVDy9tsAaeg/edit?usp=sharing&ouid=106267317093893487584&rtpof=true&sd=true";
export const instructionDorenczenia =
  "https://docs.google.com/document/d/1LgAhEQnDNJaEiqrR_k6HXQyOMu5D_F1m/edit?usp=sharing&ouid=106267317093893487584&rtpof=true&sd=true";
export const instructionPodatki =
  "https://docs.google.com/document/d/1EdkkXBz6Vec-z7Cd4dhnx5pDFC_HjQkA/edit?usp=sharing&ouid=106267317093893487584&rtpof=true&sd=true";
export const instructionZus1 =
  "https://docs.google.com/document/d/1PBbezK7ICX-BkPwziFDHiwKqFyxj2-Lt/edit?usp=sharing&ouid=106267317093893487584&rtpof=true&sd=true";
export const instructionZus2 =
  "https://docs.google.com/document/d/1ba_1QB1wKqDWFEE0JUbDor-Me1cHUAIP/edit?usp=sharing&ouid=106267317093893487584&rtpof=true&sd=true";
export const instructionZus3 =
  "https://docs.google.com/document/d/1Z0Rt3JHnaJkBa1r6oQ_dSlyYwg5lp1EN/edit?usp=sharing&ouid=106267317093893487584&rtpof=true&sd=true";
